import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './Register.css';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import CONFIG from '../config';


function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otpStep, setOtpStep] = useState('phone');
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(''));
  const [otpServerCode, setOtpServerCode] = useState('');
  const [otpTimer, setOtpTimer] = useState(0);
  const [otpVerified, setOtpVerified] = useState(false);
  const [policyAccepted, setPolicyAccepted] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [channel, setChannel] = useState('');

  // New: popup state
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  const [selectedChannels, setSelectedChannels] = useState([]);
const [customChannel, setCustomChannel] = useState('');
  const otpInputRefs = useRef([]);

const websiteOptions = [
  "www.uficon.com","education.uficon.com",
"huaweihub.uficon.com"]

const [selectedWebsite, setSelectedWebsite] = useState('');
const [isSubmitting, setIsSubmitting] = useState(false);
const [scanFromParam, setScanFromParam] = useState('');

// Existing-customer lookup (runs after OTP verification)
const [lookupUser, setLookupUser] = useState(null);
const [identityPopupVisible, setIdentityPopupVisible] = useState(false);
const [isLookingUp, setIsLookingUp] = useState(false);
const [prefilledFromLookup, setPrefilledFromLookup] = useState(false);

const branchOptions = [
  'iStudio at Fashion Island',
  'iStudio at The Mall Lifestore Ngamwongwan',
  'iStudio at The Promenade',
  'iStudio at Robinson Trang',
  'iStudio at Terminal 21 Asok',
  'iStudio at Terminal 21 Korat',
  'U•Store at Srinakharinwirot University',
  'U•Store at Mahidol University Faculty of Public Health',
  'U•Store at Siriraj Piyamaharajkarun Hospital',
  'U•Store at Siam University',
  'U•Store at Prince of Songkla University',
  'U•Store at Ubon Ratchathani Rajabhat University',
  'U•Store at Walailak University',
  'U•Store by UFicon at Srinakharinwirot University Ongkharak Campus',
  'U•Store by UFicon at Suratthani Rajabhat University',
  'U•Store by UFicon at Walailak University Hospital',
  'iMedic at Fashion Island',
  'iMedic The Mall Lifestore Ngamwongwan',
  'iMedic Robinson Trang',
  'Huawei Store at The Mall Lifestore Ngamwongwan',
  'iStudio at Central Krabi',
  'HUAWEI at Central Krabi',
].sort((a, b) => a.localeCompare(b));
const [selectedBranch, setSelectedBranch] = useState('');


const requestOtp = async () => {
  try {
    const response = await axios.post(
      `${CONFIG.API_BASE_URL}/user-line-oa/request-otp`,
      new URLSearchParams({ cust_tel: phone }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    console.log('OTP Response:', response.data);
    alert(`ส่งรหัส OTP ไปยังเบอร์ ${phone} แล้ว`);
    return response.data.otp_code;
  } catch (error) {
    console.error('OTP request failed:', error);
    alert('ไม่สามารถส่งรหัส OTP ได้ กรุณาลองใหม่');
    throw error;
  }
};


const handleChannelChange = (option) => {
  if (selectedChannels.includes(option)) {
    setSelectedChannels(selectedChannels.filter(item => item !== option));
  } else {
    setSelectedChannels([...selectedChannels, option]);
  }
};


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const scanFromQuery = queryParams.get('scan_from');
    const scanFromStored = localStorage.getItem('scan_from');
    const normalizedScanFrom = (scanFromQuery || scanFromStored || '').trim();

    if (scanFromQuery && normalizedScanFrom) {
      localStorage.setItem('scan_from', normalizedScanFrom);
    }

    if (normalizedScanFrom) {
      setScanFromParam(normalizedScanFrom);
      setSelectedBranch(normalizedScanFrom);
      setSelectedChannels((prev) =>
        prev.includes('ไม่ระบุสาขา') ? prev : [...prev, 'ไม่ระบุสาขา']
      );
    }

    const rememberedUsername = localStorage.getItem('username');
    const rememberedPassword = localStorage.getItem('password');
    if (rememberedUsername && rememberedPassword) {
      setUsername(rememberedUsername);
      setPassword(rememberedPassword);
      setRememberMe(true);
    }
  }, [location.search]);

  useEffect(() => {
    if (otpStep !== 'otp' || otpTimer <= 0) return;
    const intervalId = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [otpStep, otpTimer]);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const navigateToLogin = () => {
    navigate('/');
  };

  const knownOptions = [
  'Facebook / Instagram',
  'สาขาหน้าร้าน',
  'เว็บไซต์ของร้าน',
  'TikTok',
  'Shopee / Lazada',
  'Google / Google Maps',
  'Line OA',
  'เพื่อนแนะนำ ผ่านมหาวิทยาลัย / โรงเรียน',
  'ผ่านมหาวิทยาลัย / โรงเรียน',
  'ป้าย LED ภายในห้าง',
  'ป้าย LED หน้าห้าง',
  'อื่น ๆ',
];

  // Show the popup with a given message
  const showPopup = (message) => {
    setPopupMessage(message);
    setPopupVisible(true);
  };

  // Hide the popup
  const hidePopup = () => {
    setPopupVisible(false);
    setPopupMessage('');
  };

  // --- Existing-customer lookup helpers -------------------------------------

  // DB rows store birthdate as free-form TEXT. <input type="date"> needs
  // YYYY-MM-DD, so normalise the common shapes and give up quietly otherwise.
  const normalizeBirthdate = (value) => {
    if (!value) return '';
    const text = String(value).trim();
    const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
    const slashed = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slashed) {
      const [, d, m, y] = slashed;
      // Buddhist-era years (2500+) need converting to CE
      const year = Number(y) > 2400 ? Number(y) - 543 : Number(y);
      return `${year}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    }
    return '';
  };

  // Most rows predate the first_name/last_name columns and only have `name`,
  // so fall back to splitting it on whitespace.
  const splitName = (record) => {
    const first = (record.first_name || '').trim();
    const last = (record.last_name || '').trim();
    if (first || last) return { first, last };

    const parts = (record.name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return { first: '', last: '' };
    if (parts.length === 1) return { first: parts[0], last: '' };
    return { first: parts[0], last: parts.slice(1).join(' ') };
  };

  const lookupExistingUser = async (phoneDigits) => {
    setIsLookingUp(true);
    try {
      const res = await axios.get(
        `${CONFIG.API_BASE_URL}/user-line-oa/get_user_by_phone/${phoneDigits}`
      );
      const record = res.data;
      // PDPA gate. The backend already withholds records without consent, but
      // re-check here so the prefill can never fire on an unconsented record.
      if (record?.personal_data_protection_consent !== true) return null;
      if (record.name || record.first_name || record.email) {
        return record;
      }
      return null;
    } catch (err) {
      // 404 is the normal "new customer" path — not an error worth surfacing.
      if (err?.response?.status !== 404) {
        console.error('Existing-user lookup failed:', err);
      }
      return null;
    } finally {
      setIsLookingUp(false);
    }
  };

  const applyLookupToForm = (record) => {
    const { first, last } = splitName(record);
    if (first) setFirstName(first);
    if (last) setLastName(last);
    if (record.email) setUsername(record.email);

    const birth = normalizeBirthdate(record.birthdate);
    if (birth) setBirthDate(birth);

    // Only accept a branch we still offer, otherwise the <select> shows blank.
    if (record.branch && branchOptions.includes(record.branch)) {
      setSelectedBranch(record.branch);
    }

    if (record.know_from) {
      const known = record.know_from.split(',').map((k) => k.trim()).filter(Boolean);
      const matched = known.filter((k) => knownOptions.includes(k));
      const unmatched = known.filter((k) => !knownOptions.includes(k));
      if (matched.length) {
        setSelectedChannels((prev) => Array.from(new Set([...prev, ...matched])));
      }
      if (unmatched.length) {
        setSelectedChannels((prev) => Array.from(new Set([...prev, 'อื่น ๆ'])));
        setCustomChannel(unmatched.join(', '));
      }
    }

    setPrefilledFromLookup(true);
  };

  const handleIdentityConfirm = () => {
    if (lookupUser) applyLookupToForm(lookupUser);
    setIdentityPopupVisible(false);
  };

  const handleIdentityReject = () => {
    setLookupUser(null);
    setIdentityPopupVisible(false);
  };

  const formatPhoneForDisplay = (value) => {
    const digits = value.replace(/\D/g, '');
    if (!digits) return '';
    const raw = digits.startsWith('0') ? digits.slice(1) : digits;
    if (raw.length < 9) return `(+66) ${raw}`;
    return `(+66) ${raw.slice(0, 2)}-${raw.slice(2, 5)}-${raw.slice(5, 9)}`;
  };

  const handleRequestOtp = async () => {
    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length !== 10) {
      showPopup('เบอร์โทรศัพท์ต้องมี 10 หลัก');
      return;
    }
    if (!policyAccepted) {
      showPopup('กรุณากดยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดการใช้');
      return;
    }

    try {
      const otp = await requestOtp();
      setOtpServerCode(String(otp));
      setOtpDigits(Array(6).fill(''));
      setOtpTimer(59);
      setOtpStep('otp');
      setTimeout(() => otpInputRefs.current[0]?.focus(), 0);
    } catch (error) {
      console.error('OTP request failed:', error);
    }
  };

  const fillOtpDigits = (startIndex, rawValue) => {
    const digits = rawValue.replace(/\D/g, '');
    if (!digits) return;

    setOtpDigits((prev) => {
      const next = [...prev];
      for (let i = 0; i < digits.length && startIndex + i < next.length; i += 1) {
        next[startIndex + i] = digits[i];
      }
      return next;
    });

    const lastFilledIndex = Math.min(startIndex + digits.length - 1, otpDigits.length - 1);
    const nextFocusIndex = Math.min(lastFilledIndex + 1, otpDigits.length - 1);
    otpInputRefs.current[nextFocusIndex]?.focus();
  };

  const handleOtpChange = (index, value) => {
    const digits = value.replace(/\D/g, '');
    if (!digits) {
      setOtpDigits((prev) => {
        const next = [...prev];
        next[index] = '';
        return next;
      });
      return;
    }

    if (digits.length > 1) {
      fillOtpDigits(index, digits);
      return;
    }

    setOtpDigits((prev) => {
      const next = [...prev];
      next[index] = digits;
      return next;
    });

    if (index < 5) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpPaste = (index, event) => {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') || '';
    fillOtpDigits(index, pasted);
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !otpDigits[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otpDigits.join('');
    if (enteredOtp.length !== 6) {
      showPopup('กรุณากรอกรหัส OTP ให้ครบ');
      return;
    }
    if (enteredOtp !== String(otpServerCode)) {
      showPopup('รหัส OTP ไม่ถูกต้อง');
      return;
    }
    setOtpVerified(true);
    setOtpStep('form');

    // Phone ownership is now proven, so look the number up and offer to
    // prefill the form if we already know this customer.
    const phoneDigits = phone.replace(/\D/g, '');
    const existing = await lookupExistingUser(phoneDigits);
    if (existing) {
      setLookupUser(existing);
      setIdentityPopupVisible(true);
    }
  };

  const handleResendOtp = async () => {
    if (otpTimer > 0) return;
    try {
      const otp = await requestOtp();
      setOtpServerCode(String(otp));
      setOtpDigits(Array(6).fill(''));
      setOtpTimer(59);
      setTimeout(() => otpInputRefs.current[0]?.focus(), 0);
    } catch (error) {
      console.error('OTP resend failed:', error);
    }
  };

  const policyCheckStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    appearance: 'none',
    border: '1px solid grey',
    outline: 'none',
    cursor: 'pointer',
    marginRight: '8px',
    backgroundColor: policyAccepted ? 'grey' : 'white',
    backgroundImage: policyAccepted
      ? 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'white\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\' class=\'feather feather-check\'%3E%3Cpath d=\'M20 6L9 17l-5-5\'/%3E%3C/svg%3E")'
      : 'none',
    backgroundSize: '12px 12px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative'
  };

  const handleSubmit = async () => {
    setIsSubmitting(false);
    if (!otpVerified) {
      showPopup('กรุณายืนยัน OTP');
      return;
    }

    // 1. Check that all fields are non-empty
    if (!username.trim()) {
      showPopup('กรุณากรอกอีเมล');
      return;
    }
    if (!password) {
      showPopup('กรุณากรอกรหัสผ่าน');
      return;
    }
    if (!confirmPassword) {
      showPopup('กรุณายืนยันรหัสผ่าน');
      return;
    }
    if (password !== confirmPassword) {
      showPopup('รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน');
      return;
    }
    if (!firstName.trim()) {
      showPopup('กรุณากรอกชื่อจริง');
      return;
    }
    if (!lastName.trim()) {
      showPopup('กรุณากรอกนามสกุล');
      return;
    }
    if (!phone) {
      showPopup('กรุณากรอกเบอร์โทรศัพท์');
      return;
    }
    if (!birthDate) {
      showPopup('กรุณาเลือกวันเกิด');
      return;
    }

    const finalChannelList = selectedChannels.includes('อื่น ๆ')
  ? [...selectedChannels.filter(c => c !== 'อื่น ๆ'), customChannel.trim()]
  : selectedChannels;

if (finalChannelList.length === 0 || finalChannelList.some(c => !c)) {
  showPopup('กรุณาเลือกหรือกรอกช่องทางที่ทราบร้าน');
  return;
}

    if (!policyAccepted) {
      showPopup('กรุณากดยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดการใช้');
      return;
    }


    // 2. Validate phone length (exactly 10 digits)
    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length !== 10) {
      showPopup('เบอร์โทรศัพท์ต้องมี 10 หลัก');
      return;
    }

    // 3. Validate password rules
    const passwordMinLength = 8;
    const hasNumber = /[0-9]/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    if (
      password.length < passwordMinLength ||
      (!hasNumber.test(password) && !hasSpecialChar.test(password))
    ) {
      showPopup('รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษรและประกอบด้วยตัวเลขหรือตัวอักษรพิเศษ');
      return;
    }

    
    if (isSubmitting) return; // prevent double submission
    setIsSubmitting(true);

    try {
      // 4. Build FormData for user-line-oa/create
      const url = 'https://sso-uficon-xuvbdxggia-uc.a.run.app/register';
      const userLogin = username.split('@')[0];

      const postData = new FormData();
      postData.append("invbill", "Uficon");
      postData.append("birthdate", birthDate);
      postData.append("invcust_name", `${firstName} ${lastName}`);
      postData.append("cust_tel", phoneDigits);
      postData.append("is_policy_accepted", policyAccepted);
      postData.append("channel", channel);
      postData.append("line_user_id", localStorage.getItem('line_user_id'));
      postData.append("email", username);
      postData.append("branch", selectedBranch);
      postData.append("known_form", finalChannelList.join(", "));
      postData.append("scan_from", scanFromParam || "");

      const createRes = await axios.post(
        `${CONFIG.API_BASE_URL}/user-line-oa/create`,
        postData
      );
      // The response payload is assumed to be { message: "...", id: <newId> }
      const newUserId = createRes.data.id;
      console.log("Created user with ID:", newUserId);

      // 2) Fetch all “point events” from /coupon/
      //    (adjust the query‐string exactly as your backend expects)
      const couponRes = await axios.get(
        `${CONFIG.API_BASE_URL}/point-events/`,
        {
          params: {
            page: 1,
            limit: 1000
          }
        }
      );
      const events = couponRes.data.content.data; 
      // events is an array of objects like { event_id, target_register, reward_value_fixed, start_at, end_at, ... }

      // 3) For each event that has target_register=true AND now ∈ [start_at, end_at], call add-point
      const now = new Date();
      for (const ev of events) {
        // Check if this event qualifies
        if (ev.target_register) {
          const start = new Date(ev.start_at);
          const end = new Date(ev.end_at);
          if (now >= start && now <= end) {
            const increment = ev.reward_value_fixed || 0;
            if (increment > 0) {
              try {
                // We send as x-www-form-urlencoded: increment=<number>
                await axios.post(
                  `${CONFIG.API_BASE_URL}/user-line-oa/add-point/${newUserId}`,
                  new URLSearchParams({ increment: increment.toString() }),
                  {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }
                );
                console.log(`Added ${increment} points for event ${ev.event_id}`);
              } catch (err) {
                console.error(`Failed to add ${increment} points for event ${ev.event_id}:`, err);
              }
            }
          }
        }
      }

      await manualAddCoupon();

      // 5. Check user existence
      const checkResponse = await axios.post(
        `https://sso-uficon-xuvbdxggia-uc.a.run.app/check-user?user_login=${userLogin}`
      );

      // 6. Register on sso endpoint
      const payload = new URLSearchParams({
        user_login: checkResponse.data.user_login,
        user_email: username,
        user_pass: password,
        display_name: checkResponse.data.user_login,
        user_nicename: checkResponse.data.user_login,
        is_policy_accepted: policyAccepted.toString(),
        channel: channel,
      });
      try{
          await axios.post(url, payload, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      }catch (err) {
        console.error("Error registering user:", err);
      }
   

      // 7. Immediately log in
      const loginParams = new URLSearchParams();
      loginParams.append('username', username);
      loginParams.append('password', password);

      try{
      const loginResponse = await axios.post(
        'https://sso-uficon-xuvbdxggia-uc.a.run.app/login',
        loginParams,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      }catch (err) {
        console.log("Error logging in:", err);
      }




      // 8. Remember credentials if needed
      if (rememberMe) {    
        localStorage.setItem('username', username);
        localStorage.setItem('password', password);

      } else {
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }

      // 9. Redirect to login page (or wherever you need)
      navigate('/');
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error posting to API:', error);
      setPopupMessage('ขออภัย! คุณมีข้อมูลในระบบแล้ว หรือ มีข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
      setPopupVisible(true);
    } finally {
      setIsSubmitting(false);
      navigate('/');
    }
  };

  // Function to force redeem a coupon
  const forceRedeemCoupon = async (couponId) => {
    try {
      const response = await axios.post(
        `${CONFIG.API_BASE_URL}/coupon/force_redeem_coupon`,
        null,
        {
          params: {
            line_user_id: localStorage.getItem('line_user_id'),
            coupon_id: couponId
          },
          headers: {
            accept: 'application/json'
          }
        }
      );
      console.log("Force redeem coupon succeeded:", response.data);
    } catch (error) {
      console.error("Force redeem coupon failed:", error);
    }
  };

  async function manualAddCoupon() {
    await forceRedeemCoupon(56);
    await forceRedeemCoupon(58);
    await forceRedeemCoupon(61);
    await forceRedeemCoupon(62);

  }
  

  return (
    <div>

          {isSubmitting ? 
          <div style={{ marginTop: '10px', textAlign: 'center', color: '#00a9a5' }}>
            กำลังดำเนินการ โปรดรอสักครู่...
          </div> :       <header>
        <div style={{ width: '100%', backgroundColor: 'white' }}>
          <div style={{ padding: '50px' }}>
            {otpStep === 'phone' && (
              <div>
                <img src="/assets/logo U-01.png" alt="Logo" className="logo-image"  />
                <div className="welcome-text">Welcome to UFicon</div>
                <div className="login-header">สมัครสมาชิก</div>

                <div className="input-group-userinput">
                  <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
                    <li>เบอร์โทรศัพท์</li>
                  </ul>
                  <input
                    type="tel"
                    style={{ marginTop: 10,
                    width: '100%',
                    height: 48,
                    padding: 12,
                    borderRadius: 10,
                    border: '1px solid #e5e5e5',
                    color: '#333333',
                    boxShadow: 'none',
                    boxSizing: 'border-box',
                    outline: 'none'
                  }}
                    placeholder="กรุณากรอกเบอร์โทรศัพท์"
                    value={phone}
                    onChange={(e) => {
                      const input = e.target.value;
                      const digitsOnly = input.replace(/\D/g, '');
                      if (digitsOnly.length <= 10) {
                        setPhone(digitsOnly);
                      }
                    }}
                  />
                </div>

                <div className="policy-header-register" style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="policyCheck"
                    checked={policyAccepted}
                    style={policyCheckStyle}
                    onChange={(e) => {
                      setPolicyAccepted(e.target.checked);
                    }}
                  />
                  <div>
                    <div>
                      ฉันได้อ่านและยอมรับ&nbsp;
                      <a
                        onClick={() => navigate('/privacy-and-policy')}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#00a9a5', textDecoration: 'none' }}
                      >
                        นโยบายความเป็นส่วนตัว
                      </a>
                      &nbsp;และ
                    </div>
                    <div>
                      <a
                        onClick={() => navigate('/term-and-conditions')}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#00a9a5', textDecoration: 'none' }}
                      >
                        ข้อกำหนดการใช้
                      </a>
                      &nbsp;ของบริษัท ยูฟิคอน จำกัด
                    </div>
                  </div>
                </div>

                <div className="input-group-userinput">
                  <button onClick={handleRequestOtp} className="login-button">
                    เข้าสู่ระบบ
                  </button>
                </div>
              </div>
            )}

            {otpStep === 'otp' && (
              <div className="otp-screen">
                <img src="/assets/logo U-01.png" alt="Logo" className="logo-image"  />
                <div className="welcome-text">Welcome to UFicon</div>
                <div className="login-header">ยืนยัน OTP</div>
                <div className="otp-subtitle">
                  กรุณากรอกเลข OTP ที่ส่งไปยังหมายเลข
                  <div>{formatPhoneForDisplay(phone)}</div>
                </div>

                <div className="otp-container">
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (otpInputRefs.current[index] = el)}
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete={index === 0 ? 'one-time-code' : 'off'}
                      maxLength={1}
                      className="otp-input"
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      onPaste={(e) => handleOtpPaste(index, e)}
                    />
                  ))}
                </div>

                <div className="otp-resend">
                  {otpTimer > 0 ? (
                    <div>ส่งรหัสยืนยัน (OTP) อีกครั้ง {`00:${otpTimer.toString().padStart(2, '0')}`} นาที</div>
                  ) : (
                    <button type="button" onClick={handleResendOtp}>
                      ส่งรหัสยืนยัน (OTP) อีกครั้ง
                    </button>
                  )}
                </div>

                <div className="input-group-userinput">
                  <button onClick={handleVerifyOtp} className="login-button">
                    ยืนยัน
                  </button>
                </div>
              </div>
            )}

            {otpStep === 'form' && (
              <div>
                <img src="/assets/logo U-01.png" alt="Logo" className="logo-image"  />
                <div className="welcome-text">Welcome to UFicon</div>
                <div className="login-header">สมัครสมาชิก</div>
                {prefilledFromLookup && (
                  <div
                    style={{
                      margin: '0 0 12px',
                      padding: '10px 12px',
                      backgroundColor: '#e6f7f6',
                      border: '1px solid #00a9a5',
                      borderRadius: '4px',
                      fontSize: '14px',
                      color: '#00706e',
                      textAlign: 'left'
                    }}
                  >
                    เรากรอกข้อมูลเดิมของคุณให้แล้ว กรุณาตรวจสอบและแก้ไขได้ก่อนกดสมัครสมาชิก
                  </div>
                )}

           

            {/* First Name */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
            <li>ชื่อจริง</li>
          </ul>
              <input
                type="text"
                style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>

            {/* Last Name */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
            <li>นามสกุล</li>
          </ul>
              <input
                type="text"
                style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>

            {/* Phone */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
            <li>เบอร์โทรศัพท์</li>
          </ul>
              <input
                type="tel"
                style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                backgroundColor: '#f0f0f0',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                placeholder="0812345678"
                value={phone}
                readOnly
              />
            </div>

            {/* Birth Date */}
            <div className="input-group-userinput">
  <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
    <li>วันเกิด</li>
  </ul>
  <div className="datepicker-wrapper">
    <input
      type="date"
      style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
      value={birthDate}
      onChange={(e) => setBirthDate(e.target.value)}
      max={new Date().toISOString().split('T')[0]}
    />
  </div>
</div>
 {/* Email */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
            <li>Your Email</li>
          </ul>
              <input
                type="text"
                style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                placeholder="example@email.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            {/* Password */}
          

            <div className="input-group-userinput">

              {/* <div className="input-label">Password</div> */}
                <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
            <li>Password</li>
          </ul>
              <div className="password-container" style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '65%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}
                >
                  {showPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
                </span>
              </div>
              <div style={{ marginTop: '8px', paddingLeft: '20px', fontSize: '11px', color: 'grey', textAlign: 'left' }}>
                รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษรและประกอบด้วยตัวเลขหรือตัวอักษรพิเศษ
              </div>
            </div>

            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
                <li>Confirm Password</li>
              </ul>
              <div className="password-container" style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '65%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}
                >
                  {showPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
                </span>
              </div>
            </div>


            {/* Channel */}
           <div className="input-group-userinput">
  <ul style={{ marginTop: '15px', fontWeight: 'bold',listStyleType: 'none', paddingLeft: 0 }}>
    <li>ท่านรู้จักร้าน iStudio / U•Store by UFicon ผ่านช่องทางใด</li>
  </ul>

  <div style={{ paddingLeft: '10px', paddingTop: '10px' }}>
    {knownOptions.map((option) => (
      <div key={option} style={{ marginBottom: '8px' }}>
        <label style={{ display: 'flex', alignItems: 'center', fontFamily: 'Prompt', fontSize: '14px' }}>
          <input
            type="checkbox"
            checked={selectedChannels.includes(option)}
            onChange={() => handleChannelChange(option)}
            style={{ marginRight: '10px' }}
          />
          {option}
        </label>
       {option === 'อื่น ๆ' && selectedChannels.includes('อื่น ๆ') && (
  <input
    className="input-field"
    type="text"
    placeholder="โปรดระบุช่องทางอื่น ๆ"
    value={customChannel}
    onChange={(e) => setCustomChannel(e.target.value)}
    style={{ marginTop: '10px', marginLeft: '30px' }}
  />
)}

{option === 'สาขาหน้าร้าน' && selectedChannels.includes('สาขาหน้าร้าน') && (
  <div style={{ marginTop: '10px', marginLeft: '30px' }}>
    <select
      value={selectedBranch}
      onChange={e => setSelectedBranch(e.target.value)}
      style={{
        width: '100%',
        padding: '8px',
        fontSize: '12px',
        fontFamily: 'Prompt',
        borderRadius: '4px',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
      }}
    >
      <option value="" disabled>-- กรุณาเลือกสาขา --</option>
      {branchOptions.map(branch => (
        <option key={branch} value={branch}>
          {branch}
        </option>
      ))}
    </select>
  </div>
)}


{option === 'เว็บไซต์ของร้าน' && selectedChannels.includes('เว็บไซต์ของร้าน') && (
  <div style={{ marginTop: '10px', marginLeft: '30px' }}>
    {websiteOptions.map(site => (
      <div key={site} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
        <label style={{ fontSize: '12px', fontFamily: 'Prompt', display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={selectedWebsite.includes(site)}
            onChange={() => {
              if (selectedWebsite.includes(site)) {
                setSelectedWebsite(selectedWebsite.filter(s => s !== site));
              } else {
                setSelectedWebsite([...selectedWebsite, site]);
              }
            }}
            style={{ marginRight: '8px' }}
          />
          {site}
        </label>
      </div>
    ))}
  </div>
)}





      </div>
    ))}
  </div>
</div>



            {/* Policy Checkbox */}
            {/* <div className="policy-header-register" style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                id="policyCheck"
                checked={policyAccepted}
                style={policyCheckStyle}
                onChange={(e) => {
                  setPolicyAccepted(e.target.checked);
                }}
              />
              <div>
                <div>
                  ฉันได้อ่านและยอมรับ&nbsp;
                  <a
                    onClick={() => navigate('/privacy-and-policy')}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#00a9a5', textDecoration: 'none' }}
                  >
                    นโยบายความเป็นส่วนตัว
                  </a>
                  &nbsp;และ
                </div>
                <div>
                  <a
                    onClick={() => navigate('/term-and-conditions')}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#00a9a5', textDecoration: 'none' }}
                  >
                    ข้อกำหนดการใช้
                  </a>
                  &nbsp;ของบริษัท ยูฟิคอน จำกัด
                </div>
              </div>
            </div> */}

            {/* Submit Button */}
            <div className="input-group-userinput">
              <button onClick={handleSubmit} className="login-button">
                ยืนยัน
              </button>
            </div>
            <br/><br/><br/><br/><br/><br/>

            {/* Already a member link */}
            {/* <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Prompt',
                fontSize: '13px',
                marginTop: '10px'
              }}
            >
              <div style={{ padding: '10px' }}>เป็นสมาชิกอยู่แล้ว,</div>
              <div style={{ color: '#00a9a5', fontWeight: 'bold' }} onClick={navigateToLogin}>
                เข้าสู่ระบบ
              </div>
            </div> */}
          </div>
            )}
          </div>
        </div>
      </header>
        }



      {/* "Is this you?" confirmation — shown when the verified phone number
          already matches a customer record. */}
      {identityPopupVisible && lookupUser && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '24px 20px',
              borderRadius: '8px',
              maxWidth: '90%',
              width: '320px',
              textAlign: 'center',
              boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}
          >
            <div style={{ marginBottom: '8px', fontSize: '16px', color: '#333' }}>
              เราพบข้อมูลสมาชิกสำหรับเบอร์นี้
            </div>
            <div
              style={{
                marginBottom: '4px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#00a9a5'
              }}
            >
              {(() => {
                const { first, last } = splitName(lookupUser);
                return [first, last].filter(Boolean).join(' ') || lookupUser.name;
              })()}
            </div>
            <div style={{ marginBottom: '20px', fontSize: '15px', color: '#333' }}>
              ใช่คุณหรือไม่?
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={handleIdentityReject}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  backgroundColor: 'white',
                  color: '#555',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '15px'
                }}
              >
                ไม่ใช่
              </button>
              <button
                onClick={handleIdentityConfirm}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  backgroundColor: '#00a9a5',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '15px'
                }}
              >
                ใช่
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Custom Popup Modal */}
      {popupVisible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              maxWidth: '90%',
              width: '320px',
              textAlign: 'center',
              boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}
          >
            <div style={{ marginBottom: '16px', fontSize: '16px', color: '#333' }}>
              {popupMessage}
            </div>
            <button
              onClick={hidePopup}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00a9a5',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ตกลง
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Register;
